<template>
  <v-row>
    <v-col cols="12">
      <v-form ref="profileForm" v-model="valid" lazy-validation>
        <v-card elevation="0" tile outlined style="max-width: 350px">
          <v-simple-table>
            <thead>
              <tr>
                <th class="text-center"><div class="mt-4">名前</div></th>
                <th></th>
              </tr>
            </thead>
            <tr>
              <td>
                <v-text-field
                  v-model="userAuthQuery.name"
                  class="ms-5 me-4"
                  style="max-width: 200px"
                  :rules="[presenceValidation]"
                  required
                />
              </td>
              <td>
                <v-btn
                  color="primary"
                  dark
                  tile
                  outlined
                  @click="updateUserAuth"
                >
                  変更
                </v-btn>
              </td>
            </tr>
          </v-simple-table>
        </v-card>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { deserialize } from 'deserialize-json-api'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  mixins: [formValidationUtils],
  data: () => {
    return {
      userAuthQuery: {},
      valid: true
    }
  },
  computed: {
    ...mapState({
      currentUserAuth: (state) => state.UserAuthStore.currentUserAuth
    })
  },
  mounted: function () {
    axios.get(`/api/master/user_auths/${this.currentUserAuth.id}`).then(
      ({ data }) => {
        this.userAuthQuery = deserialize(data.data).attributes
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: error.response.data.errors.toString()
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    validateForm () {
      this.valid = this.$refs.profileForm.validate()
    },
    updateUserAuth () {
      this.validateForm()
      if (!this.valid) {
        return false
      }
      axios
        .patch(
          `/api/master/user_auths/${this.currentUserAuth.id}`,
          this.userAuthQuery
        )
        .then(
          () => {
            const payload = {
              status: 200,
              message: '変更を保存しました'
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          },
          (error) => {
            const payload = {
              status: error.response.status,
              message: error.response.data.errors.toString()
            }
            this.$store.dispatch('SystemMessageStore/createMessage', payload)
          }
        )
      this.valid = true
    }
  }
}
</script>
